import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { pingLogin } from '../../../Actions/Dashboard/login';
import { getFilters, changeFilter } from '../../../Actions/Dashboard/activities';
import api from '../../../lib/api';

class ActivityType extends React.Component {
  componentDidMount() {
    if (this.props.login) {
      api.setToken(this.props.login);
      this.props.dispatch(pingLogin(this.props.login.access_token, this.props.login.refresh_token));
      this.props.dispatch(getFilters(this.props.pathway, this.props.activityfilter));
    }
  }

  update = (e) => {
    this.props.dispatch(changeFilter(e.target.value));
  }


  render() {
    let string = 'Filter by type';

    // console.log('test', this.props.options);

    if (this.props.options) {
      this.props.options.map((key) => {
        if (key.type === this.props.defaultValue) {
          string = key.type;
        }
        return null;
      });
    }

    return (
      <div className="niceselect-wrapper">
        <span className="niceselect-text">{string}</span>
        <select onChange={this.update} defaultValue={this.props.pathway}>
          <option value="">Please Select</option>
          {this.props.options && this.props.options.map(v => <option value={v.type} key={v.type}>{v.type}</option>)}
        </select>
      </div>
    );
  }
}

ActivityType.propTypes = {
  dispatch: PropTypes.func.isRequired,
  activityfilter: PropTypes.string,
  login: PropTypes.object.isRequired,
};

ActivityType.defaultProps = {
  activityfilter: '',
};

export default connect(state => ({
  options: (state.activityfilters ? state.activityfilters.data : []),
  pathway: state.pathway,
  login: state.login,
  activityfilter: state.activityfilter,
}), dispatch => ({ dispatch }))(ActivityType);



// WEBPACK FOOTER //
// ./src/Components/Dashboard/Components/ActivityType.jsx